<template>
  <h1>redirect to gls-group.eu</h1>
</template>

<script>
export default {
  created() {
    setTimeout(() => {
      location.href = 'https://gls-group.eu/'
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// client/views/Redirect.vue